import React, {  Fragment } from "react";
import { NavLink , useHistory} from 'react-router-dom';
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
import About from "../../component/Section/About";
import Contact from "../../component/Section/Contact";
import Service from "../../component/Section/Service";
import SliderConstruction from "../../component/Slider/SliderConstruction";

const Index = (props) => {
  const history = useHistory(); // useHistory hook'unu burada kullanın

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };
  const service = [
    {
      id:1,
      img: "./../images/ds (1).png",
      title: "Panel Çit",
      desc: "Panel Çit Nedir? Panel çit sınır belirleyici özelliğinin yanı sıra çevre güvenliğini de sağlayan ve aynı zamanda her mekana dekoratif ve estetik görsellik kazandıran bir tel örgü sistemidir. Panel Çit Özellikleri Panel çit, tel örgülü yapısından dolayı simetrik, şık ve dekoratif bir görünüme sahip olan panel çitlerin tel kaplamaları, statik boyanın galvaniz üzerine uygulanması ile yapılmaktadır.",
      url:"1"
    },
    {
      id:2,
      img: "./../../images/dekoraçit (5).png",
      title: "Dekoraçim",
      desc: "Çim çit Dekoraçim, dekoratif, dayanıklı ve sağlam yapısı ile günümüzde oldukça sık tercih edilen bir çim çit türüdür. Çim ve çit’in birleşiminden meydana gelen ürün dekoraçim adı ile bilinmektedir.",
      url:"5"
    },
    {
      img: "./../images/telçit (1).png",
      title: "Tel Çit Sistemleri",
      desc: "Tel çit sistemleri sınırları belli olan bir bölge temel alınarak, o sınırlar içerisinde bulunan başka bir alanla çakışma yaşama gibi bir durumun engellenmek istenmektedir. Bu amaçla bir bölge ile sınır belirlemek ya da o bölgeyi korumak, bölgenin kendisine ait bir araziye sahip olduğunu gösterebilmek için kullanılmakta olan çevreleme sistemlerine tel çit sistemleri adı verilmektedir.",
      url:"3"
    },
  ]

  
  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="position-relative">
          <img src="./../images/Bg.png" className="images__wrap-head" alt="" />
          <div className="wrapper__bg-head"></div>
          <Navbar />
          <section className="position-relative z-2">
            <div className="container">
              <div className="text-center">
                <h1 className="semi-bold font__size--90 text__90-1024 text__90-md text__90-sm text__90-xs  color__white text-uppercase mb-0">Tel ve çit sektöründe 1994'ten beri tecrübe kazanmış  <br className="d-none d-sm-block" /> Eymen Tel Çit size hizmet sunmaya devam ediyor.</h1>
                <p className="medium roboto font__size--16 text__16-1024 color__white my-4"><br className="d-none d-sm-block" /></p>

                <div className="d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-center">
                  <NavLink to={`/servislerimiz`} className="btn__mm-w-60 semi-bold rounded-0 font__size--14 text__14-1024 btn btn__orange shadow color__white text-uppercase" onClick={handleLinkClick}>Servislerimize Göz Atın</NavLink>
                  
                </div>
              </div>
            </div>
          </section>
        </div>

        <About />

        <Service service={service} />

        <section className="overflow-hidden">
          <div className="text-center mb-5">
            <p className="semi-bold font__size--14 text__14-1024 color__orange text-uppercase"></p>
            <h3 className="bold font__size--58 text__50-1024 text__50-sm text__50-xs text-uppercase">Projelerimiz</h3>
          </div>
          <SliderConstruction />
        </section>

        

        <Contact />

        <Footer />
      </div >
    </Fragment >
  );
};

export default Index;
